import React from 'react';
import styles from './whitebox.module.scss';

interface Props {
	children: any;
	wrapperStyle?: any;
	customStyle: any;
	customClass?: any;
}

export const WhiteBox = ({ children, wrapperStyle, customStyle, customClass }: Props) => (
	<div className={`${styles.wrapperBox} wrapperBox`} style={wrapperStyle}>
		<div className={`${styles.whiteBox} whiteBox ${styles[customClass]}`} style={customStyle}>
			{children}
		</div>
	</div>
);

export default WhiteBox;
